"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Button = function Button(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "action-area"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: props.enabled ? 'button-continue--selected change-plan-button' : 'button-continue',
    disabled: props.enabled ? '' : 'disabled',
    id: "button",
    onClick: props.onClick
  }, props.enabled ? 'Continue' : 'Select Option')));
};
Button.propTypes = {
  enabled: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
var _default = Button;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');